<template>
    <div>
        <layout>
            <Search slot="header-bar" placeholder="请输入关键字搜索" v-model="input" @search="onRefresh">
                <div slot="left-icon">
                    <button slot="left-icon" @click="searState"
                            style="border: none;background-color: white;border-right: 1px solid #EEEEEE;margin-right: 5px;">
                        {{stateName}}
                    </button>
                </div>
            </Search>
            <PullRefresh v-model="isReFresh" @refresh="onRefresh">
                <List
                        style="margin-top:-5px;padding: 5px 12px"
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        loading-text="拼命加载中..."
                        @load="onLoad"
                        :offset="50"
                        :immediate-check="true"
                >
                    <InspectItem v-for="item in inspectList" :key="item.id" :inspect="item"/>
                </List>
            </PullRefresh>
        </layout>
        <SelectDict :showAll="true" dictKey="INSPECT_TSAK_STATE" :show="selectShow"
                    @cancel="selectShow=false" @ok="onStateOk"/>
    </div>
</template>

<script>
    import {List, PullRefresh, Search} from "vant"
    import InspectItem from "./components/InspectItem";
    import {formatSearchData} from "@/utils/format";
    import SelectTreePopup from "@/components/SelectPopup/SelectTreePopup"
    import SelectDict from "@/components/SelectPopup/SelectDict";


    export default {
        components: {SelectDict, SelectTreePopup, InspectItem, Search, PullRefresh, List},
        props: {},
        data() {
            return {
                stateName: "全部",
                state: "",
                selectShow: false,
                input: null,
                isReFresh: false,
                loading: false,
                finished: false,
                inspectList: []
            }
        },
        computed: {},
        created() {
        },
        mounted() {
        },
        methods: {
            searState() {
                this.selectShow = true;
            },
            onStateOk(data) {
                this.stateName = data.codeName;
                if (data.code == "All") this.state = null;
                else this.state = data.code;
                this.onRefresh()
                this.selectShow = false;
            },
            onRefresh() {
                this.isReFresh = true;
                this.inspectList = [];
                this.onLoad(true);
            },
            onLoad(isPullRefresh) {
                const data = {
                    name: this.input,
                    state: this.state,
                    unitId: this.$default.unitOrOrgan.id,
                    size: 20,
                    //  page: this.inspectList.length / 20 + 1
                }
                formatSearchData(data)
                this.$http.tokiot.inspectTask.list(data).then(res => {
                    if (res) {
                        this.inspectList.push(...res.rows);
                        this.loading = false;
                        if (isPullRefresh) this.isReFresh = false;
                        if (this.inspectList.length >= res.total) {
                            this.finished = true;
                        }
                    }
                })
            },
        },
        watch: {}
    }
</script>

<style scoped>


</style>